"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/EmptyState.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');













// A settings section with nothing in it yet (F-5): what goes here, then the
// one thing to do about it, or why it can't be done yet.
const EmptyState = ({ title, children, action, reason, reasonActions }) => (
  _react2.default.createElement('div', { className: "settings--empty-state", role: "group", 'aria-label': title, __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
    , _react2.default.createElement('h3', { className: "settings--empty-state--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}},  title )
    , _react2.default.createElement('p', { className: "settings--empty-state--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}},  children )
    ,  action && _react2.default.createElement(_Form.Button, { onClick: action.onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}},  action.label ) 
    ,  !action && reason && _react2.default.createElement('p', { className: "settings--empty-state--reason", role: "note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}},  reason ) 
    ,  !action && reasonActions && _react2.default.createElement('div', { className: "settings--empty-state--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  reasonActions ) 
  )
)

exports. default = EmptyState
